import { useEffect, useState } from 'react'
import { useRouterState } from '@tanstack/react-router'

// Top-of-page loading bar tied to the router's pending state. Loaders fetch from
// Sanity on navigation; this gives immediate feedback while the old page stays
// visible, instead of a frozen URL. Preload ('intent') makes most navs instant,
// so the 120ms delay below keeps the bar from flashing on those.
export function NavigationProgress() {
  const isPending = useRouterState({ select: (s) => s.status === 'pending' })
  const [width, setWidth] = useState(0)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (isPending) {
      const show = setTimeout(() => {
        setVisible(true)
        setWidth(10)
      }, 120)
      // Trickle toward 90% — never reaches 100 until the load actually finishes.
      const trickle = setInterval(() => {
        setWidth((w) => (w > 0 && w < 90 ? w + (90 - w) * 0.15 : w))
      }, 200)
      return () => {
        clearTimeout(show)
        clearInterval(trickle)
      }
    }
    // Load done: snap to 100%, then fade out and reset.
    if (visible) setWidth(100)
    const hide = setTimeout(() => {
      setVisible(false)
      setWidth(0)
    }, 250)
    return () => clearTimeout(hide)
  }, [isPending]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!visible) return null
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-0.5">
      <div
        className="h-full bg-primary transition-[width,opacity] duration-200 ease-out"
        style={{ width: `${width}%`, opacity: width >= 100 ? 0 : 1 }}
      />
    </div>
  )
}
